import { render, staticRenderFns } from "./AddBankpopup.vue?vue&type=template&id=958d8074"
import script from "./AddBankpopup.vue?vue&type=script&lang=js"
export * from "./AddBankpopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports